'use strict';

class BaseScene {
  constructor(app) {
    this.app = app;
    this.buttons = [];
  }

  enter() {}

  exit() {
    this.buttons = [];
  }

  update() {}

  render() {}

  handleTouch(type, point) {
    if (type !== 'start') return;
    for (let i = this.buttons.length - 1; i >= 0; i -= 1) {
      if (this.buttons[i].contains(point.x, point.y)) {
        this.app.feedback.tap();
        this.buttons[i].tap();
        return;
      }
    }
  }

  drawButtons(ctx) {
    for (let i = 0; i < this.buttons.length; i += 1) this.buttons[i].draw(ctx);
  }
}

module.exports = BaseScene;

